
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(08|66|91)|8(21|33|95)|214|709|964)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
